import React from "react";
import TimeAgo from "react-timeago";
import { NavLink } from "react-router-dom";
import Image from "../../../partials/Image";

const SingleStaffList = ({ staff = [] }) => {
    return (
        <table className="table full-width table-bordered">
            <thead>
                <tr>
                    <th className="text-center">sn</th>
                    <th>Image</th>
                    <th> Name </th>
                    <th> Designation </th>
                    <th> Mobile </th>
                    <th>Joining Date</th>
                    <th className="text-center"> Actions </th>
                </tr>
            </thead>
            {staff.map((item, idx) => (
                <tbody key={idx}>
                    <tr>
                        <td className="text-center">{idx + 1}</td>
                        <td className="patient-img">
                            <Image src={item.image} alt={item.surname} height={50} width={50} />
                        </td>
                        <td>
                            <NavLink
                                to={{
                                    pathname: "/home/staffing/profile",
                                    search: `?ref=${item.id}`
                                }}
                            >
                                <strong>
                                    {item.surname} {item.first_name} {item.middle_name} {item.admin && <span className="badge badge-success">Admin</span>}
                                </strong>
                                <div className="text-muted">
                                    <span>{item.email} </span>
                                </div>
                            </NavLink>
                        </td>
                        <td>
                            {item.type.name} |{" "}
                            <strong>
                                <span className="text-primary">{item.designation && item.designation.name}</span>
                            </strong>
                            <div className="text-muted">
                                NIN: <span>{item.nin || "None"} </span>
                            </div>
                        </td>
                        <td>
                            <a href={`tel:${item.mobile}`}>{item.mobile}</a>
                        </td>
                        <td>
                            <TimeAgo date={item.created_at} />
                        </td>
                        <td className="text-center">
                            {/* View item profile action button */}
                            <NavLink
                                to={{
                                    pathname: "/home/staffing/profile",
                                    search: `?ref=${item.id}`
                                }}
                                className="btn btn-tbl-edit btn-xs"
                                title="View Profile"
                            >
                                <i className="fa fa-user"></i>
                            </NavLink>

                            {/* Assign patients to item action button*/}
                            <NavLink
                                to={{
                                    pathname: "/home/staffing/assign-patient",
                                    state: { activeStaff: item }
                                }}
                                className="btn btn-tbl-edit btn-xs"
                                title="Assign Patient"
                            >
                                <i className="fa fa-book"></i>
                            </NavLink>

                            {/* Edit item action button */}
                            <NavLink
                                to={{
                                    pathname: "/home/staffing/edit",
                                    state: { activeStaff: item }
                                }}
                                className="btn btn-tbl-edit btn-xs"
                                title="Edit"
                            >
                                <i className="fa fa-pencil"></i>

                                {/* Delete item action button */}
                            </NavLink>
                            <NavLink
                                to={{
                                    pathname: "/home/re-auth",
                                    search: `?pathname=/home/staffing/list&func=staff&ref=${item.id}`
                                }}
                                className="btn btn-tbl-delete btn-xs"
                                title="Delete"
                            >
                                <i className="fa fa-trash-o"></i>
                            </NavLink>
                        </td>
                    </tr>
                </tbody>
            ))}
        </table>
    );
};

export default SingleStaffList;
